<template>
  <page-wrapper :title="title" :has-pad="true">
    <div class="wrapper">
      <div class="container">
        <notice-editor v-model="form" :language="localization.TH"></notice-editor>
        <div class="text-end mt-4">
          <sc-button variant="primary" @click="handleClickSave"
            >บันทึก</sc-button
          >
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { localization } from "@/lib/mapper";

import NoticeEditor from "../components/NoticeEditor";

function createEmptyForm() {
  return {
    title: "",
    subtitle: "",
    projects: [],
    publishDate: null,
    calendarDate: null
  };
}

export default {
  components: {
    PageWrapper,
    ScButton,
    NoticeEditor
  },
  data() {
    return {
      localization,
      title: "เพิ่มประกาศ",
      form: createEmptyForm()
    };
  },
  methods: {
    async handleClickSave() {
      const { title, projects, publishDate } = this.form;
      if (
        title === "" ||
        !projects.length ||
        !publishDate ||
        !publishDate.start ||
        !publishDate.end
      ) {
        this.$message.error("กรุณากรอกข้อมูลให้ครบ");
        return;
      }

      try {
        await this.createNotice();
        this.$router.push({ name: "NoticeListPage" });
      } catch (err) {
        this.$message.error("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
    },
    async createNotice() {
      const { title, projects, subtitle, publishDate, calendarDate } = this.form;

      const projectIds = projects.map(({ projectId }) => projectId);

      const params = {
        title,
        subtitle,
        projectIds,
        publishDate: {
          start: publishDate.start.toISO(),
          end: publishDate.end.toISO()
        },
        calendarDate: calendarDate
          ? {
              start: calendarDate.start.toISO(),
              end: calendarDate.end.toISO()
            }
          : undefined
      };

      const response = await baanRueJaiClient.admin.communications.notices.post(
        params
      );

      return response.data.result;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.wrapper {
  padding: $space 0;
}

.editor {
  margin-bottom: $space;
}
</style>
